import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { Formik, Form, FastField } from 'formik';
import Button from '@material-ui/core/Button';
import { Typography, InputLabel, Paper, Box, Tooltip } from '@material-ui/core';
import { Help } from '@material-ui/icons';
import _e from 'common/localeUtil';
import GMSelect from '../form/GMSelect';
import TextInputField from '../form/TextInputField';
import { api } from '../../redux/services/api';
import GenericDialog from './GenericDialog';
import LabelValueComponent from '../LabelValueComponent';
import FieldWrapper from '../form/FieldWrapper';
import {
	getColorHexUsingComputedStyle,
	getTemplateSectionConfig,
	getTitleFromSection,
	handleColorChangedForSection,
	handleSaveInEditConfigurationDialog,
} from '../../utils';

const useStyles = makeStyles((theme) => ({
	boxContent: {
		padding: theme.spacing(2),
		backgroundColor: theme.palette.background.paper,
	},
	descriptionWrapper: {
		paddingBottom: theme.spacing(2),
	},
	eachComponent: {
		width: 300,
		marginBottom: theme.spacing(2.5),
		'& label': {
			marginBottom: theme.spacing(1),
			display: 'block',
		},
	},
	formWrapper: {
		paddingTop: theme.spacing(2),
		'& .submitButton': {
			textAlign: 'right',
		},
	},
	testimonialStyleImg: {
		width: 80,
		height: 35,
	},
	navButtonColorLabel: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
	},
	helpIcon: {
		marginLeft: theme.spacing(1),
		color: theme.palette.primary.main,
		width: theme.spacing(2),
		height: theme.spacing(2),
	},
}));

// const numSlidesData = [
// 	{
// 		name: '1',
// 		value: 1
// 	},
// 	{
// 		name: '2',
// 		value: 2
// 	},
// 	{
// 		name: '3',
// 		value: 3
// 	}
// ];
const testimonialStyleData = [
	{
		name: 'Style 1',
		value: 'style1',
		previewImg:
			'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSCjJLCz0iKdTJmUEEJikIMgN6cJpaTY1KHFA&usqp=CAU',
	},
	{
		name: 'Style 2',
		value: 'style2',
		previewImg:
			'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSCjJLCz0iKdTJmUEEJikIMgN6cJpaTY1KHFA&usqp=CAU',
	},
	{
		name: 'Style 3',
		value: 'style3',
		previewImg:
			'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSCjJLCz0iKdTJmUEEJikIMgN6cJpaTY1KHFA&usqp=CAU',
	},
	{
		name: 'Style 4',
		value: 'style4',
		previewImg:
			'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSCjJLCz0iKdTJmUEEJikIMgN6cJpaTY1KHFA&usqp=CAU',
	},
	{
		name: 'Style 5',
		value: 'style5',
		previewImg:
			'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSCjJLCz0iKdTJmUEEJikIMgN6cJpaTY1KHFA&usqp=CAU',
	},
];

const EditTestimonialsDialog = (props) => {
	// console.log('EditTestimonialsDialog props', props);
	const { open, handleClose, sectionId } = props;
	const classes = useStyles();
	// const testimonials = useStoreState(state => state.template.testimonials);
	const testimonialsSettings = useStoreState((state) => state.template.testimonialsSettings);
	const templateId = useStoreState((state) => state.template.template);
	let templateConfig = getTemplateSectionConfig(templateId, 'testimonials');
	// should have some default values
	templateConfig = {
		title: true,
		slideSpeed: true,
		height: true,
		style: true,
		...templateConfig,
	};
	const setTestimonialsSettings = useStoreActions(
		(actions) => actions.template.setTestimonialsSettings,
	);

	const handleSave = async (values) => {
		console.log('EditTestimonialsDialog handleSave', values);
		// Save to DB
		await api.post(
			`${process.env.REACT_APP_BASE_API_URL}/private/rest/accounts/adviser_agent/save_sitesettings_details/`,
			{
				testimonials_settings: { ...values },
			},
		);
		setTestimonialsSettings({ ...values });
		const htmlTestimonials = window.testimonialsMessagesHTML;
		if (window.grapesjs.Canvas.getWindow().applyTestimonials) {
			window.grapesjs.Canvas.getWindow().applyTestimonials(
				window.selectedTemplate,
				htmlTestimonials,
				values,
				true,
			);
		}

		handleSaveInEditConfigurationDialog(values, sectionId);

		handleClose && handleClose();
	};

	// const {
	// 	noSliders = 1,
	// 	textColor = '#000000',
	// 	slideSpeed = '5000',
	// 	height = 400,
	// 	style = 'style1'
	// } = testimonialsSettings || {};
	// console.log('EditTestimonialsDialog initialValues', testimonialsSettings);

	const title = getTitleFromSection(sectionId);
	const headerColorHex = getColorHexUsingComputedStyle('testimonials', 'header');
	// const navButtonColor = getColorHexUsingComputedStyle('testimonials', 'navButtonColor', {
	// 	colorProperty: 'fill'
	// });

	const initialValues = {
		noSliders: 1,
		textColor: '#000000',
		slideSpeed: '5000',
		height: 400,
		style: 'style1',
		navButtonColor: templateConfig.navButtonColor,
		// slideSpeed: '4000',
		// noSliders: 2,
		// style: 'style3'
		...testimonialsSettings,
		headerColor: headerColorHex,
		title,
	};

	const renderForm = () => {
		return (
			<Form className={classes.formWrapper}>
				{templateConfig && templateConfig?.title && (
					<LabelValueComponent
						label={<InputLabel>{_e('title')}</InputLabel>}
						value={<TextInputField name="title" placeholder="" />}
					/>
				)}
				{/*{templateConfig && templateConfig?.slideSpeed && (*/}
				{/*	<LabelValueComponent*/}
				{/*		label={<InputLabel>Slide Speed (ms)</InputLabel>}*/}
				{/*		value={<TextInputField name="slideSpeed" lightBackground />}*/}
				{/*	/>*/}
				{/*)}*/}
				{templateConfig && templateConfig?.title && (
					<LabelValueComponent
						label={<InputLabel>{_e('header_color')}</InputLabel>}
						value={
							<FastField
								callback={handleColorChangedForSection('testimonials', 'header')}
								defaultHex={headerColorHex}
								name="headerColor"
								component={FieldWrapper}
								control="colorpicker"
							/>
						}
					/>
				)}
				<LabelValueComponent
					label={<InputLabel>{_e('text_color')}</InputLabel>}
					value={
						<FastField
							defaultHex={initialValues.textColor}
							name="textColor"
							component={FieldWrapper}
							control="colorpicker"
						/>
					}
				/>
				{templateConfig && templateConfig?.height && (
					<LabelValueComponent
						label={<InputLabel>{_e('height')}</InputLabel>}
						value={<TextInputField name="height" lightBackground type="number" />}
					/>
				)}

				{/*<LabelValueComponent*/}
				{/*	label={<InputLabel>Number of slides to scroll</InputLabel>}*/}
				{/*	value={<GMSelect name="noSliders" data={numSlidesData} />}*/}
				{/*/>*/}

				{templateConfig && templateConfig?.style && (
					<LabelValueComponent
						label={<InputLabel>{_e('testimonial_style')}</InputLabel>}
						value={
							<GMSelect
								name="style"
								data={testimonialStyleData}
								itemRenderer={(item) => {
									return (
										<Box display="flex" flexDirection="row" alignItems="center">
											<img
												className={classes.testimonialStyleImg}
												src={item.previewImg}
												alt={item.name}
											/>
											<Box pl={2}>{item.name}</Box>
										</Box>
									);
								}}
							/>
						}
					/>
				)}
				<LabelValueComponent
					labelClasses={classes.navButtonColorLabel}
					label={
						<>
							<InputLabel>{_e('navigation_button_color')}</InputLabel>
							<Tooltip title={_e('navigation_button_color_tooltip')}>
								<Help className={classes.helpIcon} />
							</Tooltip>
						</>
					}
					value={
						<FastField
							defaultHex="#ffffff"
							name="navButtonColor"
							component={FieldWrapper}
							control="colorpicker"
						/>
					}
				/>

				<Box p={1} pt={2}>
					<div className="submitButton">
						<Button
							variant="contained"
							color="primary"
							type="submit"
							// onClick={handleSave}
						>
							{_e('save')}
						</Button>
					</div>
				</Box>
			</Form>
		);
	};

	const renderContent = () => {
		return (
			<div className={`useImageBrowseWrapper`}>
				<Paper elevation={0} className={classes.boxContent}>
					<Typography variant="body1" className="bold-text" gutterBottom>
						{_e('your_testimonials')}
					</Typography>
					<Typography variant="body2">
						{_e('your_testimonials_desc', { html: true })}
					</Typography>
					<Formik
						initialValues={initialValues}
						onSubmit={async (values, { setSubmitting }) => {
							// showFormikValues(values, setSubmitting);
							await handleSave(values);
							setSubmitting(false);
						}}
					>
						{renderForm}
					</Formik>
				</Paper>
				<Box p={1} />
			</div>
		);
	};
	return (
		<GenericDialog
			shadedContent
			maxWidth="md"
			title={_e('testimonials')}
			subtitle={_e('testimonials_desc')}
			content={renderContent()}
			showTitleDivider
			handleClose={handleClose}
			open={open}
			hideConfirmButton
		/>
	);
};

EditTestimonialsDialog.propTypes = {
	open: PropTypes.bool,
	handleClose: PropTypes.func,
	sectionId: PropTypes.string,
};

export default EditTestimonialsDialog;
